module.exports = {"pt-BR":{"properties":{"list":{"empty":"Nenhum imóvel encontrado nesta região"}}}}